export const FLIGHTS_SHARE_DIRECT_LABEL = "flights-share-direct";
export const FLIGHTS_SHARE_META_LABEL = "flights-share-meta";
export const FLIGHTS_IOS_SHARE_DIRECT_LABEL = "flights-ios-share-direct";
export const FLIGHTS_IOS_SHARE_META_LABEL = "flights-ios-share-meta";
export const FLIGHTS_ANDROID_SHARE_DIRECT_LABEL = "flights-android-share-direct";
export const FLIGHTS_ANDROID_SHARE_META_LABEL = "flights-android-share-meta";
export const GOOGLE_TAG_MANAGER_CONTAINER_ID = "AW-1070314322";
export const GOOGLE_TAG_MANAGER_CONTAINER_LABEL = "7zaICNHurMQBENLmrv4D";
export const GOOGLE_FLIGHTS_EXT_ORIGIN_PARAM_VALUES = ["gfs", "gfsapi"];
export const GOOGLE_SEARCH_WIDGET_EXT_ORIGIN_PARAM_VALUES = ["google-widget"];
export const SKYSCANNER_EXT_ORIGIN_PARAM_VALUES = ["skyscanner"];
export const KAYAK_EXT_ORIGIN_PARAM_VALUES = ["kayak"];
export const WEGO_EXT_ORIGIN_PARAM_VALUES = ["wego"];
export const FLYGRESOR_EXT_ORIGIN_PARAM_VALUES = ["flygresor.se"];
